import { defineVariant } from '../v4/theme';

const MONO = '"JetBrains Mono","IBM Plex Mono","Courier New",monospace';

/* v7 "Terminal": amber phosphor HUD in dark mode, thermal-paper printout in light mode. */
export const V7_VARIANT = defineVariant({
  id: 'v7',
  basePath: '/v7',
  brand: 'ECOSCOPE',
  tag: 'v7 · terminal',
  defaultMode: 'dark',
  font: MONO,
  fontsHref: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700;800&display=swap',
  radius: 4,
  tokens: {
    dark: {
      bg:            '#0a0805',
      text:          '#ffd28a',
      'muted-rgb':   '204,160,90',
      'fg-rgb':      '255,190,90',
      'surface-rgb': '20,14,6',
      'surface2-rgb':'15,11,5',
      'shadow-rgb':  '0,0,0',
      cyan:          '#ffb000',
      'cyan-light':  '#ffc94d',
      'cyan-deep':   '#8a5a00',
      'on-accent':   '#1a1000',
      green:         '#7dff6a',
      red:           '#ff5c39',
      'red-soft':    '#ff7a5c',
      orange:        '#ff8c1a',
      purple:        '#d38cff',
      gold:          '#ffe066',
      blue:          '#66c2ff',
      teal:          '#4dffd2',
      neutral:       '#6b5a3a',
      whatsapp:      '#7dff6a',
      'glow-k':      '1',
    },
    light: {
      bg:            '#efe8d8',
      text:          '#2b2113',
      'muted-rgb':   '90,72,45',
      'fg-rgb':      '43,33,19',
      'surface-rgb': '250,245,233',
      'surface2-rgb':'245,239,224',
      'shadow-rgb':  '60,40,10',
      'shadow-k':    '0.25',
      cyan:          '#a65f00',
      'cyan-light':  '#c77a10',
      'cyan-deep':   '#6b3d00',
      green:         '#3d7a1f',
      red:           '#b3361b',
      'red-soft':    '#b3361b',
      orange:        '#b8620a',
      purple:        '#7a3fa0',
      gold:          '#8f6d00',
      blue:          '#1f5f99',
      teal:          '#1a7f6b',
      neutral:       '#a89a7e',
      whatsapp:      '#3d7a1f',
      'glow-k':      '0',
    },
  },
  /* Everything in monospace; tighter, slightly wider-tracked text. */
  globalStyles: () => ({
    'body, body *:not(svg):not(path)': { fontFamily: `${MONO} !important` },
    '::selection': { background: 'var(--v4-cyan)', color: 'var(--v4-bg)' },
  }),
});
